export default __webpack_public_path__ + "static/media/mitigation-water-damage-hallway.13b8960d.jpg";